// Create a new file: /components/workflow/RestructureNode.jsx

import React from 'react';
import { Handle, Position } from 'reactflow';
import { GitMerge } from 'lucide-react'; // Icon for restructuring/merging
import { BsBraces } from 'react-icons/bs'; // NEW: Import icon for JSON output indicator

const RestructureNode = ({ data }) => {
  const statusStyles = {
    idle: 'border-indigo-700',
    pending: 'border-yellow-400',
    queued: 'border-blue-400',
    failed: 'border-red-500',
    success: 'border-green-500',
    running: 'animate-[pulse_1s_infinite] border-green-500',
    approvalNeeded: 'animate-[glow_1.5s_infinite] border-orange-500',
    diagnosing: 'animate-[pulse_1s_infinite] border-purple-500', // 👈 new line
  };

  // Default to 'idle' if status is not provided or invalid
  const status = data?.status || 'idle';
  const isLoading =
    status === 'running' || status === 'pending' || status === 'diagnosing';

  const hasJsonOutput = data?.jsonOutput === true;

  const outputFieldCount = Object.keys(
    data.jsonOutputSchema?.properties || {},
  ).length;

  return (
    <div
      className={`w-64 rounded-lg border-2 bg-zinc-800 shadow-lg ${statusStyles[status]}`}
    >
      <div className="flex items-center justify-between gap-3 rounded-t-lg border-b border-zinc-700 bg-zinc-900/50 p-3">
        <div className="flex items-center gap-2">
          <GitMerge className="text-indigo-400" size={20} />
          <h3 className="text-base font-bold text-white">Restructure Data</h3>
        </div>
        <div className="flex items-center gap-2">
          {hasJsonOutput && (
            <div title="Structured JSON Output Enabled" className="cursor-help">
              <BsBraces className="h-4 w-4 text-cyan-400" />
            </div>
          )}
          {isLoading && (
            <div className="h-4 w-4 animate-spin rounded-full border-2 border-zinc-500 border-t-white" />
          )}
        </div>
      </div>
      <div className="space-y-1 p-3 text-xs text-slate-300">
        <p>
          <span className="font-semibold text-slate-400">Label:</span>{' '}
          {data.label || 'Data Mapper'}
        </p>
        <p>
          <span className="font-semibold text-slate-400">Mappings:</span>{' '}
          {Object.keys(data.mappings || {}).length}
        </p>
        <p>
          <span className="font-semibold text-slate-400">Output Fields:</span>{' '}
          {outputFieldCount}
        </p>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        className="h-3 w-3 !bg-teal-500"
      />
      <Handle
        type="target"
        position={Position.Left}
        className="h-3 w-3 !bg-rose-500"
      />
    </div>
  );
};

export default RestructureNode;
